export default "__VITE_ASSET__Dh0XUn_r__"